module.exports = __webpack_public_path__ + "product1.865e1cbf.png";